import { useCookies } from '@vueuse/integrations/useCookies';
import UniversalCookies from 'universal-cookie';
import dayjs from 'dayjs';

import publicKey from '../../public.pem?raw';
import privateKey from '../../private.pem?raw';

const TokenKey = 'Admin-Token';
const AdminTempTokenKey = 'adminTempToken';

const Cookies = useCookies(
  [TokenKey, AdminTempTokenKey, 'username', 'password', 'rememberMe'],
  undefined,
  new UniversalCookies(null, { path: '/', sameSite: 'strict' }),
);

const expires = dayjs().add(1, 'month').toDate();

export function getTokenHeader() {
  const header = { Authorization: getToken() ? `Bearer ${getToken()}` : '' };
  return header;
}

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token: string) {
  return Cookies.set(TokenKey, token);
}

// 获取tempToken
export function getAdminTempToken() {
  return Cookies.get(AdminTempTokenKey);
}

// 设置tempToken
export function setAdminTempToken(token: string) {
  return Cookies.set(AdminTempTokenKey, token);
}

export function removeToken() {
  Cookies.remove(AdminTempTokenKey);

  return Cookies.remove(TokenKey);
}

export function getUserName() {
  return Cookies.get('username');
}

export function setUserName(name: string) {
  return Cookies.set('username', name, { expires });
}

export async function getPassword() {
  return await decodeURIComponent(encodeURIComponent(atob(Cookies.get('password'))));
}

export async function setPassword(pwd: string) {
  return Cookies.set('password', btoa(pwd), { expires });
}

export function getRememberMe() {
  return Cookies.get('rememberMe');
}

export function setRememberMe(flag: string) {
  return Cookies.set('rememberMe', flag, { expires });
}

export function removeUserName() {
  return Cookies.remove('username');
}

export function removePassword() {
  return Cookies.remove('password');
}

export function removeRememberMe() {
  return Cookies.remove('rememberMe');
}

export function setUReport(filePath: string, fileName: string) {
  return Cookies.set(filePath, fileName, { expires: dayjs().add(1, 'hour').toDate() });
}
